import React, { useEffect, useState } from 'react';
import { TextField, Grid, Select, InputLabel, FormControl, MenuItem } from '@mui/material';
import { useNewCampaign } from '../../../../../contexts/NewCampaignContext';

const TwilioForm = ({ columns, template }) => {
  const { activeInputRef, setTwilioTemplateData, twilioTemplateData } = useNewCampaign();
  const [bccOpen, setBccOpen] = useState(false);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setTwilioTemplateData(name, value);
  };
  const safeColumns = Array.isArray(columns) ? columns : [];
  useEffect(() => { 

  }, [twilioTemplateData]);

  const handleFocus = (event) => {
    activeInputRef.current = event.target;
  };

  return (
    <form noValidate autoComplete="off">
      <Grid container spacing={2} style={{ marginTop: '2rem' }}>
        <Grid item xs={6}>
          <TextField
            label="From Number"
            value={template ? template.action_config.from_number : twilioTemplateData.fromNumber}
            name="fromNumber"
            fullWidth
            InputLabelProps={{ shrink: true }}
            onChange={handleChange}
            onFocus={handleFocus}
            required
          />
        </Grid>
        <Grid item xs={6}>
          <FormControl fullWidth>
            <InputLabel id="to-number-label">To Number</InputLabel>
           <Select
    labelId="to-number-label"
    value={
      template
        ? template.action_config.to_number
        : twilioTemplateData.toNumber || ''
    }
    onChange={handleChange}
    onFocus={handleFocus}
    name="toNumber"
    required
  >
    {safeColumns.length === 0 ? (
      <MenuItem disabled>No columns available</MenuItem>
    ) : (
      safeColumns.map((col, i) => (
        <MenuItem key={i} value={`{{${col.name}}}`}>
          {`{{${col.name}}}`}
        </MenuItem>
      ))
    )}
  </Select>

          </FormControl>
        </Grid>
      </Grid>
    </form>
  );
};

export default TwilioForm;
